import React, { useRef, useState } from 'react';
import { ScanLine, Loader2 } from 'lucide-react';
import { carsysApi } from '../api/carsysApi';
import { useT } from '../context/LanguageContext';
import { toast } from 'sonner';

// Verklein de foto client-side zodat de upload klein blijft.
const verkleinFoto = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const img = new Image();
    img.onload = () => {
      const max = 1600;
      let { width, height } = img;
      if (width > max || height > max) {
        const r = Math.min(max / width, max / height);
        width = Math.round(width * r); height = Math.round(height * r);
      }
      const canvas = document.createElement('canvas');
      canvas.width = width; canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.8));
    };
    img.onerror = reject;
    img.src = e.target.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

/**
 * Knop: upload een foto/scan van autopapieren (NL/Duits/EU kentekenbewijs) → AI leest de gegevens.
 * Roept onResult(velden) aan met de uitgelezen voertuiggegevens.
 */
export default function ScanAutopapieren({ onResult, label, testid = 'scan-autopapieren', compact = false }) {
  const { t } = useT();
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = (e.target.files || [])[0];
    if (fileRef.current) fileRef.current.value = '';
    if (!file) return;
    setBusy(true);
    const tid = toast.loading(t('AI leest de autopapieren…', 'AI leest de autopapieren…'));
    try {
      const dataUrl = await verkleinFoto(file);
      const r = await carsysApi.scanVoertuigDocument(dataUrl);
      onResult?.(r);
      const naam = [r.merk, r.model].filter(Boolean).join(' ') || r.kenteken || '';
      toast.success(t('Gegevens ingelezen', 'Gegevens ingelezen'), { id: tid, description: naam ? `${naam}${r.landVanHerkomst ? ` · ${r.landVanHerkomst}` : ''}` : undefined });
    } catch (err) {
      toast.error(t('Inlezen mislukt', 'Inlezen mislukt'), { id: tid, description: err.response?.data?.detail || err.message });
    } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" className={`cs-btn ${compact ? '' : ''}`} onClick={() => fileRef.current?.click()} disabled={busy} data-testid={testid}>
        {busy ? <Loader2 size={14} className="spin" /> : <ScanLine size={14} />} {label || t('Scan autopapieren (AI)', 'Scan autopapieren (AI)')}
      </button>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" hidden onChange={onFile} data-testid={`${testid}-input`} />
      <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}} .spin{animation:spin 1s linear infinite}`}</style>
    </>
  );
}
